import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Grid,
  Typography,
} from "@mui/material";
import CommonButton from "../../components/common/CommonButton/CommonButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";
import ListItemIcon from "@mui/material/ListItemIcon";
import AddIcon from "@mui/icons-material/Add";

// Import the useAuth hook and the ROLES enum
import { useAuth, ROLES } from "../../components/auth/AuthContext";

export default function GradeReportsHeaderActions({
  searchText,
  onSearchChange,
  onOpenColumns,
  onOpenFilters,
  onHandleStatus,
  isStatusFilterActive,
  isAddCompaniesBtn,
  onHandleOpen,
  onCompanyQty,
  onBulkDelete
}) {
  // Access the current role from AuthContext
  const { role } = useAuth();
  
  const [activeFilter, setActiveFilter] = useState("all");
  const statusFilterActive = isStatusFilterActive;
  const addCompaniesBtnActive = isAddCompaniesBtn;
  const selectedCompanyQty = onCompanyQty;

  // Determine if the current user is an Operations user
  const isOpsUser = role === ROLES.OPERATIONS;

  const handleChange = (event) => {
    const newValue = event;
    if (onHandleStatus) {
      onHandleStatus(newValue);
    }
    setActiveFilter(newValue);
  };

  const filterButtonStyles = {
    border: "2px solid #E0E3E5",
    "& span": {
      color: "#B4B5B6",
      marginLeft: "3px",
    },
    "&:hover": {
      backgroundColor: "#D8E6F0",
      border: "solid 2px #C6D7E2",
      color: "#005786",
    },
    "&:hover span": {
      color: "#005786",
      marginLeft: "3px",
    },
    "&:focus": {
      border: "3px solid #C6D7E2",
      outline: "none",
      color: "#005786",
      backgroundColor: "#D8E6F0",
      span: {
        color: "#005786",
        marginLeft: "3px",
      },
    },
    "&:active": {
      backgroundColor: "#D8E6F0",
      border: "solid 2px #C6D7E2",
    },
  };

  const statusFilterOptions = [
    { label: "All", value: "all", qty: 10 },
    { label: "Complete", value: "complete", qty: 4 },
    { label: "Pending Completion", value: "pending_completion", qty: 1 },
    { label: "In Progress", value: "in_progress", qty: 2 },
    { label: "Pending", value: "pending", qty: 3 },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        bgcolor: "#fff",
        p: 2,
        width: "100%",
      }}
    >
      {/* Left Section (Visible to everyone) */}
      <Box display="flex" alignItems="center" gap={1.5}>
        <TextField
          size="small"
          placeholder="Search"
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{
            width: 220,
            "& .MuiOutlinedInput-root": { borderRadius: 20, fontSize: 13 },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlinedIcon fontSize="small" color="action" />
              </InputAdornment>
            ),
          }}
        />

        <Button
          variant="outlined"
          size="small"
          startIcon={<FilterAltOutlinedIcon />}
          sx={{
            borderRadius: 20,
            textTransform: "none",
            fontSize: 13,
            px: 2,
            color: "#1A1919",
          }}
          onClick={onOpenFilters}
        >
          Add Filter
        </Button>

        {/* <IconButton
          size="small"
          onClick={onOpenColumns}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: "50%",
            color: "#1A1919",
            "&:hover": {
              backgroundColor: "#005786",
              color: "#fff",
            },
          }}
        >
          <ViewListOutlinedIcon fontSize="small" />
        </IconButton> */}
      </Box>

      {/* Right Section: Conditionally render status filters ONLY if it's an Ops User */}
      {statusFilterActive && isOpsUser && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap={2}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              {statusFilterOptions.map((option) => {
                const isActive = option.value === activeFilter;

                return (
                  <Grid item xs={3} key={option.value}>
                    <CommonButton
                      autoFocus={option.label === "All"}
                      onClick={() => handleChange(option.value)}
                      variant="contained"
                      size="medium"
                      color={isActive ? "terciary" : "secondary"}
                      boxshadow={"none"}
                      sx={{
                        ...filterButtonStyles,
                        ...(isActive && {
                          fontWeight: "600",
                          color: "#005786",
                          span: {
                            color: "#005786",
                            marginLeft: "3px",
                          },
                        }),
                      }}
                    >
                      {option.label}
                      <span>{option.qty}</span>
                    </CommonButton>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      )}

      {/* Add Companies Section from dev branch */}
      {addCompaniesBtnActive && (
        <div>
          {selectedCompanyQty > 0 && (
            <div style={{ display: 'inline-flex', position: 'relative', top: '4px'}} className="fade-in">
              <div style={{ display: 'flex', marginRight: '10px'}}>
                <Typography style={{ lineHeight: '2.2'}}>
                  Selected {selectedCompanyQty}
                </Typography>

                <CommonButton
                  variant="contained"
                  size="small"
                  color="secondary"
                  sx={{ border: 'none', marginLeft: '10px' }}
                  onClick={onBulkDelete}
                >
                  Delete
                </CommonButton>
              </div>
            </div>
          )}

          <CommonButton 
            variant="contained" 
            size="medium" 
            color="secondary"
            onClick={onHandleOpen}
            sx={{ mr: 3, }}
          >
            <ListItemIcon>
              <AddIcon />
            </ListItemIcon>
            Companies
          </CommonButton>
        </div>
      )}
    </Box>
  );
}